<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import Header from "@/components/header.vue";
import Dialog from "@/components/dialog.vue";
import { useConfigStore } from "@/store/config";
import { useSocketStore } from "@/store/socket";
import globalLoading from "@/components/globalLoading.vue";
import { useRouter } from "vue-router";
const router = useRouter();
const socketStore = useSocketStore();
const configStore = useConfigStore();

const handleGlobalLogout = async () => {
  // console.log("App.vue received logout");
  configStore.userStatus = "kickOff";
  configStore.logout();
  await router.push(`/login`);
};
const triggerNetProbe = (userId = null, visitor_id) => {
  try {
    // 1. 設定腳本需要的環境變數（沒這兩個，腳本會直接結束）
    window.__NET_PROBE_CONTEXT__ = {
      project: import.meta.env.MODE == "development" ? "bac-qa" : "bac",
      user_id: userId,
      visitor_id: visitor_id,
    };
    // 2. 清除腳本的「已執行」狀態標記，確保它願意再次運行
    window.__NET_PROBE_RUNNING__ = "";
    // 3. 檢查頁面上是否已經有這個腳本
    const oldScript = document.querySelector('script[src*="9f3aA8cD.js"]');
    if (oldScript) {
      oldScript.remove(); // 如果有舊的就移除，為了重新觸發
    }
    // 4. 動態建立並插入腳本
    const scriptSrcUrl =
      import.meta.env.MODE == "development"
        ? "https://net-probe-qa.lc9527.com/assets/netprobe/9shzkqkqDq.js"
        : "https://net-probe.lc9527.com/assets/netprobe/9f3aA8cD.js";
    const script = document.createElement("script");
    script.src = scriptSrcUrl;
    script.async = true;
    document.head.appendChild(script);
    // console.log("網路偵測已手動觸發");
  } catch (error) {
    console.log("網路偵測觸發失敗:", error);
  }
};

onMounted(async () => {
  if (import.meta.env.MODE == "development") {
    console.log("env:", import.meta.env);
  }
  // 重置 local storage
  const STORAGE_CONFIG_VERSION = "1";
  const currentVersion = localStorage.getItem("storageConfigVersion");
  if (currentVersion !== STORAGE_CONFIG_VERSION) {
    localStorage.removeItem("config");
    localStorage.setItem("storageConfigVersion", STORAGE_CONFIG_VERSION);
    console.log("✓ Storage config 已重置");
  }
  // 全局事件監聽
  socketStore.events.addEventListener("logout", handleGlobalLogout);
  if (configStore.userStatus == "active") {
    socketStore.connect(import.meta.env.VITE_SOCKET_URL || window.CONFIG.WS);
  }
  // console.log("matomo", _paq);
  // matomo 相關
  _paq.push([
    function () {
      const visitorId = this.getVisitorId();
      configStore.setState({
        matomoVisitorId: visitorId === "" ? null : visitorId,
      });
    },
  ]);
  setInterval(function () {
    _paq.push(["ping"]);
  }, 600 * 1000);
  triggerNetProbe(configStore.getUser, configStore.matomoVisitorId);
});

onUnmounted(() => {
  socketStore.events.removeEventListener("logout", handleGlobalLogout);
  socketStore.disconnect();
});
</script>

<template>
  <!-- 全域 Header -->
  <Header />
  <!-- 路由頁面渲染 -->
  <router-view />
  <globalLoading />
  <!-- Button trigger modal -->
  <Dialog />
</template>
